var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDateArrow = function SvgDateArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.812 14.167-4.456-5.353a.863.863 0 0 0-.303-.231.91.91 0 0 0-.38-.083h-1.76c-.182 0-.283.198-.171.335l3.92 4.71H2.218A.213.213 0 0 0 2 13.75v1.544c0 .113.098.206.217.206h18.91c.729 0 1.134-.793.685-1.333Z",
    fill: "#666"
  })));
};
export default SvgDateArrow;